import React from "react";
import { connect } from "react-redux";

import {
  mapStateToProps,
  mapDispatchToProps,
  LoginContainer
} from "components/Login/LoginContainer";
import LoginPage from "./LoginPage";

import { SET_PRIVACY_POLICY_ACCEPTANCE_REQUIRED } from "config";
import { POST_LOGIN_GUEST } from "services/api";
import localStorageService from "services/localStorageService";
import sessionStorageService from "services/sessionStorageService";
import pushApiGenerator from "services/pushApiGenerator";
import loginServices from "services/loginServices";

export class CustomLoginContainer extends LoginContainer {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitLoading: false,
      email: "",
      password: "",
      sessionKey: null,
      userId: null,
      username: null,
      setPrivacyPolicyAcceptanceRequired: SET_PRIVACY_POLICY_ACCEPTANCE_REQUIRED,
      showPrivacyAgreement: null,
      marketingConsent: null,
      privacyAgreed: false,
      showGuestLoginDialog: false,
      userRecaptchaActivate: false,
      /* Custom: guestnickname */
      guestNickname: ""
    };

    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleUpdateMarketingConsent = this.handleUpdateMarketingConsent.bind(
      this
    );
    this.handleUpdatePrivacyAgreed = this.handleUpdatePrivacyAgreed.bind(this);

    /* Guest Login Dialogs */
    this.handleOpenGuestLoginDialog = this.handleOpenGuestLoginDialog.bind(
      this
    );
    this.handleCloseGuestLoginDialog = this.handleCloseGuestLoginDialog.bind(
      this
    );

    /* Recaptcha */
    this.handleRecaptchaError = this.handleRecaptchaError.bind(this);
    this.handleRecaptchaExpired = this.handleRecaptchaExpired.bind(this);

    /* OAuth */
    this.responseFacebook = this.responseFacebook.bind(this);
    this.responseFacebookError = this.responseFacebookError.bind(this);
    this.responseGoogle = this.responseGoogle.bind(this);
    this.responseGoogleError = this.responseGoogleError.bind(this);
    this.handleSaveSessionAndRedirect = this.handleSaveSessionAndRedirect.bind(
      this
    );

    /* Loading indicators */
    this.setSubmitLoading = this.setSubmitLoading.bind(this);

    /* Custom: guest nickname handlers */
    this.handleGuestNicknameChange = this.handleGuestNicknameChange.bind(this);
    this.handleNicknameSubmit = this.handleNicknameSubmit.bind(this);
  }

  handleGuestNicknameChange = event => {
    this.setState({ guestNickname: event.currentTarget.value });
  };

  handleNicknameSubmit = event => {
    event.preventDefault();
    const data = {
      user_name: this.state.guestNickname
    };
    pushApiGenerator(POST_LOGIN_GUEST, data).end((err, res) => {
      if (err || res.body.code !== 200) {
        if (res.body.error) {
          this.props.showAlertWithTimeout({
            text: res.body.error,
            type: "error"
          });
        }
      } else {
        localStorageService.saveState({
          user_id: res.body.user.id,
          sessionKey: res.body.sessionKey
        });
        if (
          res.body.sessionKey !== undefined &&
          res.body.user.id !== undefined
        ) {
          this.props.setUserId(res.body.user.id);
          this.props.setSessionKey(res.body.sessionKey);
        }

        // loads loginRedirectUrl from sessionStorage (if available)
        // eventually loginRedirectUrl will be dumped when new page is loaded
        // (not REGISTER nor LOGIN nor RESET_PASSWORD)
        // for the aforementioned dumping, see SingleProjectApp.js
        let loginRedirectUrl = sessionStorageService.getItem(
          "loginRedirectUrl"
        );

        /*
          We assume all guest login users are first-time users, thus firstLogin flag is unnecessary,
          thus the last parameter is true to allow no bypassing of tours.
        */
        loginServices.postLoginReplaceAndNavigate(
          this.props.projectId,
          loginRedirectUrl,
          true
        );
      }
    });
  };

  render() {
    return (
      <LoginPage
        email={this.state.email}
        password={this.state.password}
        handleEmailChange={this.handleEmailChange}
        handlePasswordChange={this.handlePasswordChange}
        handleUpdateMarketingConsent={this.handleUpdateMarketingConsent}
        handleUpdatePrivacyAgreed={this.handleUpdatePrivacyAgreed}
        handleSubmit={this.handleSubmit}
        handlePrivacySubmit={this.handlePrivacySubmit}
        showPrivacyAgreement={this.state.showPrivacyAgreement}
        marketingConsent={this.state.marketingConsent}
        privacyAgreed={this.state.privacyAgreed}
        projectId={this.props.projectId}
        topbarlessBackButtonRoute={this.getTopbarlessBackButtonRoute()}
        language={this.props.language}
        /* Guest Login Dialog */
        guestEnabled={this.props.guestEnabled}
        showGuestLoginDialog={this.state.showGuestLoginDialog}
        handleOpenGuestLoginDialog={this.handleOpenGuestLoginDialog}
        handleCloseGuestLoginDialog={this.handleCloseGuestLoginDialog}
        /* Recaptcha */
        userRecaptchaActivate={this.state.userRecaptchaActivate}
        handleRecaptchaError={this.handleRecaptchaError}
        handleRecaptchaExpired={this.handleRecaptchaExpired}
        /* OAuth */
        responseFacebook={this.responseFacebook}
        responseFacebookError={this.responseFacebookError}
        responseMicrosoft={this.responseMicrosoft}
        responseGoogle={this.responseGoogle}
        responseGoogleError={this.responseGoogleError}
        /* loading indicators */
        isSubmitLoading={this.state.isSubmitLoading}
        setSubmitLoading={this.setSubmitLoading}
        /* Custom: guest nickname handlers */
        handleGuestNicknameChange={this.handleGuestNicknameChange}
        handleNicknameSubmit={this.handleNicknameSubmit}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomLoginContainer);
